import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { fg } from '@atlassian/jira-feature-gating';
import { type Goal, useLazyGoals } from '@atlassian/jira-portfolio-3-atlas-goals';
import EllipsedWithTooltip from '@atlassian/jira-portfolio-3-portfolio/src/common/view/ellipsed-with-tooltip';
import type { Props } from './types';

// Rename to lazyGoalsByARI when plan_timeline_sort_goal_groups_alphabetically is cleaned up
export const GoalComponent = ({ goals, lazyGoalsByARI: lazyGoalsByARINew }: Props) => {
	// Remove when plan_timeline_sort_goal_groups_alphabetically is cleaned up
	const [{ lazyGoalsByARI: lazyGoalsByARIOld }] = useLazyGoals();
	const lazyGoalsByARI = fg('plan_timeline_sort_goal_groups_alphabetically')
		? lazyGoalsByARINew
		: lazyGoalsByARIOld;

	const allGoals = goals.reduce<Goal[]>((acc, goalARI) => {
		const lazyGoal = lazyGoalsByARI[goalARI]?.goal;
		if (lazyGoal) {
			acc.push(lazyGoal);
		}
		return acc;
	}, []);

	if (isEmpty(allGoals)) {
		// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
		return <span>-</span>;
	}
	const sortedGoalNames = allGoals
		.map((goal) => goal.name)
		.sort()
		.join(', ');
	const sortedGoalKeys = allGoals
		.map((goal) => goal.key)
		.sort()
		.join(', ');
	return (
		<EllipsedWithTooltip content={sortedGoalNames}>
			<span>{sortedGoalKeys}</span>
		</EllipsedWithTooltip>
	);
};
